import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="cdh-hero">
      <div className="cdh-hero__inner">
        <div className="cdh-hero__left">
          <div className="cdh-hero__chip">
            <span className="cdh-hero__chip-dot" />
            CAD Automation Engineer · 8+ years · Chennai
          </div>

          <h1 className="cdh-hero__h1">
            Your CAD skills are already strong.
            <br />
            Now make them <em>10x more valuable.</em>
          </h1>

          <p className="cdh-hero__sub">
            Learn CAD automation using APIs and become the engineer your team cannot replace.
          </p>

          <div className="cdh-hero__proof-line">
            Your manager notices the engineer who saves the team 10 hours a week. Not the one who does the same manual task faster.
          </div>

          <div className="cdh-hero__urgency">
            AI is already inside CAD tools. Engineers who only model and draft are being squeezed out. The ones who automate and build tools are moving up.
          </div>

          <div className="cdh-hero__actions">
            <Link to="/courses" className="cdh-btn cdh-btn--solid">
              Start Your Transition Today →
            </Link>
            <Link to="/about" className="cdh-btn cdh-btn--outline">
              Become a CAD Automation Engineer
            </Link>
          </div>
        </div>

        <div className="cdh-hero__right">
          <div className="cdh-compare">
            <div className="cdh-compare__row">
              <div className="cdh-compare__col">
                <div className="cdh-compare__head cdh-compare__head--grey">
                  Design Engineer
                </div>
                {[
                  "Creates 3D models manually",
                  "Draws views, adds dimensions",
                  "Fills title block by hand",
                  "Exports BOM to Excel manually",
                  "Repeats for every part",
                ].map((t) => (
                  <div className="cdh-compare__item" key={t}>
                    <span className="cdh-compare__ic cdh-compare__ic--grey">
                      ✓
                    </span>
                    {t}
                  </div>
                ))}
              </div>
              <div className="cdh-compare__col">
                <div className="cdh-compare__head cdh-compare__head--blue">
                  Automation Engineer
                </div>
                {[
                  "Script generates the model",
                  "Drawing views auto-placed",
                  "Title block auto-populated",
                  "BOM exported in one click",
                  "Runs for 500 parts overnight",
                ].map((t) => (
                  <div className="cdh-compare__item" key={t}>
                    <span className="cdh-compare__ic cdh-compare__ic--blue">
                      →
                    </span>
                    {t}
                  </div>
                ))}
              </div>
            </div>
            <div className="cdh-compare__divider" />
            <div className="cdh-compare__footer">
              <div className="cdh-compare__stat">
                <div className="cdh-compare__stat-num cdh-compare__stat-num--grey">
                  3 days
                </div>
                <div className="cdh-compare__stat-lbl">manual effort</div>
              </div>
              <div className="cdh-compare__vs">vs</div>
              <div className="cdh-compare__stat">
                <div className="cdh-compare__stat-num cdh-compare__stat-num--blue">
                  4 min
                </div>
                <div className="cdh-compare__stat-lbl">with automation</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cdh-hero__proof-row">
        <div className="cdh-hero__proof-inner">
          <div className="cdh-hero__proof-item">
            <div className="cdh-hero__proof-num">30–80%</div>
            <div className="cdh-hero__proof-lbl">higher pay</div>
          </div>
          <div className="cdh-hero__proof-item">
            <div className="cdh-hero__proof-num">10+ hrs</div>
            <div className="cdh-hero__proof-lbl">saved per week</div>
          </div>
          <div className="cdh-hero__proof-item">
            <div className="cdh-hero__proof-num">8+ yrs</div>
            <div className="cdh-hero__proof-lbl">production tools</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
